export default __webpack_public_path__ + "static/media/1884.003b63a7.png";